import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'
import { Query } from 'react-apollo'

import { SELF_QUERY } from '../../../queries'

import { GirlColor, BoyColor, Switch, Key, Cogwheel, Logout } from '../../Icons'
import {
  BottomBarDropDown,
  BottomBarDropDownItem,
  BottomBarDropDownIconContainer
} from '../../../styles/defaults-header'
import { Intro, IntroTitle, IntroSubtitle, IntroIconContainer, IntroContent } from './styles'

import helpers from '../../../helpers'

class UserMenuDropdown extends Component {
  handleClick(e) {
    this.props.onClickLink(e)
  }

  handleSwitchBranch() {
    this.props.onSwitchBranch()
  }

  render() {
    const { permissions } = this.props

    return (
      <BottomBarDropDown height="435px" main>
        <Intro>
          <IntroIconContainer>
            {this.props.gender === 'MALE' ? <BoyColor size="" /> : <GirlColor size="" />}
          </IntroIconContainer>

          <IntroContent>
            <Query query={SELF_QUERY}>
              {({ loading, error, data }) => {
                let username = ''
                const { self } = data
                if (self) {
                  self.insertion = helpers.findInsertion(self.insertion)
                  username =
                    self.firstName + ' ' + (self.insertion !== null ? self.insertion + ' ' : '') + self.lastName
                }

                return (
                  <Fragment>
                    <IntroTitle>
                      Welkom,<br />
                      {username}
                    </IntroTitle>
                    <IntroSubtitle>{this.props.branchName}</IntroSubtitle>
                  </Fragment>
                )
              }}
            </Query>
          </IntroContent>
        </Intro>
        {permissions.multipleBranches ? (
          <div onClick={this.handleSwitchBranch.bind(this)}>
            <BottomBarDropDownItem>
              <BottomBarDropDownIconContainer>
                <Switch size="" />
              </BottomBarDropDownIconContainer>
              Wissel van filiaal
            </BottomBarDropDownItem>
          </div>
        ) : null}

        {permissions.viewUsers ? (
          <Link to="/medewerkers" onClick={this.handleClick.bind(this)}>
            <BottomBarDropDownItem>
              <BottomBarDropDownIconContainer>
                <Key size="" />
              </BottomBarDropDownIconContainer>
              Medewerkers
            </BottomBarDropDownItem>
          </Link>
        ) : null}

        {permissions.editProfile ? (
          <Link to="/instellingen" onClick={this.handleClick.bind(this)}>
            <BottomBarDropDownItem>
              <BottomBarDropDownIconContainer>
                <Cogwheel size="" />
              </BottomBarDropDownIconContainer>
              Instellingen
            </BottomBarDropDownItem>
          </Link>
        ) : null}

        <Link to="/" onClick={this.props.handleLogout}>
          <BottomBarDropDownItem>
            <BottomBarDropDownIconContainer>
              <Logout size="" />
            </BottomBarDropDownIconContainer>
            Uitloggen
          </BottomBarDropDownItem>
        </Link>
      </BottomBarDropDown>
    )
  }
}

export default withRouter(UserMenuDropdown)



// WEBPACK FOOTER //
// ./src/components/MobileHeader/UserMenuDropdown/index.js